var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"popup-wrap"},[_c('div',{staticClass:"popup",style:(_vm.style),attrs:{"data-aos":"fade-down","data-aos-duration":"1500"}},[_c('p',[_vm._v(_vm._s(_vm.text))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }